import { render, staticRenderFns } from "./ActivityStreamItem.vue?vue&type=template&id=596a49a9"
import script from "./ActivityStreamItem.vue?vue&type=script&lang=js"
export * from "./ActivityStreamItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityStreamItem.vue?vue&type=style&index=0&id=596a49a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports